import isEmpty from 'lodash-es/isEmpty'

import { createRequest as createRequestByManualForm } from '../../../api'
import { EMPTY_OBJECT } from '../../../constants/common'
import {
  useInlineNotifications,
  useUkTimeZone,
  useUserData,
} from '../../../hooks'
import { clearEmptyFields } from '../../../utils/formHelpers'
import { parseServerValidation } from '../../../utils/validation'
import { FormikForm } from '../../Formik'
import { useRequestDraft } from '../Request.hooks'

import { REQUEST_FORM_INITIAL_VALUES } from './RequestForm.constants'
import {
  getRequestFormCreationPayload,
  getRequestFormValidationSchema,
} from './RequestForm.utils'
import { RequestFormFields } from './RequestFormFields'

function RequestForm({
  FormContainer,
  apiProps: { createRequest = createRequestByManualForm } = EMPTY_OBJECT,
  containerProps,
  initialValues = REQUEST_FORM_INITIAL_VALUES,
  setModal,
  onCancel,
  onError,
  onSuccess,
  ...restProps
}) {
  const user = useUserData()

  const { timezone } = useUkTimeZone()

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications()

  const validationSchema = getRequestFormValidationSchema()

  const { setDraft } = useRequestDraft()

  function handleSubmit(values, { setErrors, setSubmitting }) {
    const payload = getRequestFormCreationPayload({
      timezone,
      user,
      values,
    })

    createRequest(clearEmptyFields(payload))
      .then(({ data }) => {
        setDraft(null, 0)

        onSuccess?.(data)
      })
      .catch(({ response }) => {
        if (!isEmpty(response?.data)) {
          setSubmitting(false)
          setErrors(parseServerValidation(response?.data))
          onError()
        }
      })
  }

  return (
    <FormikForm
      enableReinitialize
      Container={FormContainer}
      containerProps={containerProps}
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <RequestFormFields
        {...restProps}
        notifications={notifications}
        setModal={setModal}
        onCancel={onCancel}
        onRemoveNotification={handleRemoveNotification}
        onSetNotification={handleAddNotification}
      />
    </FormikForm>
  )
}

export default RequestForm
